import type { FC } from "react";
import { useTranslation } from "react-i18next";

import { MuiAlert } from "@ryde/controls";
import type { DirectionEnum } from "@ryde/shared";

import { BulkBookingsDirectionScopeNoticeStyled } from "../bulk-bookings-components";

interface IDirectionScopeNoticeProps {
  direction: DirectionEnum;
  matchingCount: number;
  selectedCount: number;
}

/**
 * The run applies one time to one direction, so a selection spanning both is narrowed rather than
 * refused - the direction field is the user's own choice of what to apply it to. This only says what
 * that choice leaves out, and stays silent when it leaves nothing out.
 */
export const DirectionScopeNotice: FC<IDirectionScopeNoticeProps> = ({
  direction,
  matchingCount,
  selectedCount,
}) => {
  const { t } = useTranslation();

  if (matchingCount === selectedCount) {
    return null;
  }

  return (
    <BulkBookingsDirectionScopeNoticeStyled>
      {/* MuiAlert defaults to the assertive role="alert"; this note follows the user's own choice. */}
      <MuiAlert
        severity={matchingCount ? "info" : "warning"}
        role="status"
        aria-live="polite"
      >
        {t(
          matchingCount
            ? "booking.bulk.directionScopeNotice"
            : "booking.bulk.directionScopeEmptyNotice",
          { matchingCount, selectedCount, directionValue: direction },
        )}
      </MuiAlert>
    </BulkBookingsDirectionScopeNoticeStyled>
  );
};
